"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stockpileHistoryFrontColumnProps = exports.stockpileHistoryColumnProps = exports.stockpileColumnProps = void 0;
const constants_1 = require("utils/constants");
exports.stockpileColumnProps = [
    {
        show: true,
        field: 'stockpile_code',
        title: 'Stockpile Code',
        width: 'auto',
        filter: 'text',
    },
    {
        show: true,
        field: 'stockpile_name',
        title: 'Stockpile Name',
        width: 'auto',
        filter: 'text',
    },
    {
        show: true,
        field: 'modified_date',
        title: 'Modified Date',
        width: '220px',
        filter: 'date',
        format: `${constants_1.formatGridDate.ddMMYYYY} ${constants_1.formatGridDate.hhMM}`,
    },
    {
        show: true,
        field: 'modified_by',
        title: 'Modified By',
        width: '140px',
        filter: 'text',
    },
    {
        show: true,
        field: 'is_active',
        title: 'Status',
        width: '120px',
        filter: 'boolean',
    },
];
exports.stockpileHistoryColumnProps = [
    {
        show: true,
        field: 'ticket_no',
        title: 'Ticket No',
        width: 'auto',
        filter: 'text',
    },
    {
        show: true,
        field: 'dumptruck_no',
        title: 'DT No',
        width: '100',
        filter: 'text',
    },
    {
        show: true,
        field: 'transaction_type',
        title: 'Type',
        width: '100',
        filter: 'text',
    },
    {
        show: true,
        field: 'contractor_name',
        title: 'Contractor',
        width: 'auto',
        filter: 'text',
    },
    {
        show: true,
        field: 'penalty',
        title: 'Penalty',
        width: '100',
        filter: 'text',
    },
    {
        show: true,
        field: 'modified_date',
        title: 'Date',
        width: 'auto',
        filter: 'date',
        format: `${constants_1.formatGridDate.ddMMYYYY} ${constants_1.formatGridDate.hhMM}`,
    }
];
exports.stockpileHistoryFrontColumnProps = [
    {
        show: true,
        field: 'dumptruck_no',
        title: 'DT No',
        width: '100',
        filter: 'text',
    },
    {
        show: true,
        field: 'penalty',
        title: 'P',
        width: '60',
        filter: 'text',
    },
    {
        show: true,
        field: 'gate_in',
        title: 'Date',
        width: 'auto',
        filter: 'date',
        format: `${constants_1.formatGridDate.ddMMYYYY} ${constants_1.formatGridDate.hhMM}`,
    }
];
